import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SET_COLUMN_FILTER, TRIGGER_FILTERS } from '../../../constants';
import './ColumnFilter.css';

export default forwardRef((props, ref) => {
  const columnFilters = useSelector(
    (state) => state.timingsReportColumnFilterState,
  );

  const { field } = props;
  useImperativeHandle(ref, () => {
    return {
      isFilterActive() {
        return inputValue !== '' && argument !== '';
      },
      doesFilterPass(params) {
        return true;
      },
    };
  });
  const dispatch = useDispatch();

  const [inputError, setInputError] = useState(false);
  const [argumentError, setArgumentError] = useState(false);
  const options = [
    { value: 'GREATER', label: 'Greater than' },
    // { value: 'EQUALS', label: 'Equal to' },
    { value: 'LESSER', label: 'Lesser than' },
  ];

  const handleSelectChange = (event) => {
    setArgumentError(false);
    setArgument(event.target.value);
  };
  const formatToMilliseconds = (formattedText) => {
    const [hours, minutes] = formattedText.split(':');
    const totalMilliseconds =
      parseInt(hours, 10) * 60 * 60 * 1000 + parseInt(minutes, 10) * 60 * 1000;
    return totalMilliseconds;
  };
  const formatMillisecondsTohhhmm = (milliseconds) => {
    const hours = Math.floor(milliseconds / (60 * 60 * 1000));
    const minutes = Math.floor((milliseconds % (60 * 60 * 1000)) / (60 * 1000));
    return `${String(hours).padStart(3, '0')}:${String(minutes).padStart(
      2,
      '0',
    )}`;
  };
  const completeTime = (formattedText) => {
    const [hours, minutes] = formattedText.split(':');
    const completedHours = hours.padStart(3, '0');
    const completedMinutes = minutes ? minutes.padStart(2, '0') : '00';
    return `${completedHours}:${completedMinutes}`;
  };
  const handleInputBlur = () => {
    if (inputValue === '' || !isTimeInput()) return;
    const formattedText = formatInput(inputValue);
    const completedText = completeTime(formattedText);
    setInputValue(completeTime);
  };
  const handleInputChange = (event) => {
    setInputError(false);
    const inputText = event.target.value;
    let formattedText = inputText;
    if (isTimeInput()) {
      formattedText = formatInput(inputText);
    }
    setInputValue(formattedText);
  };

  const handleClearInput = () => {
    setInputValue('');
    setArgument('');
    setInputError(false);
    setArgumentError(false);
    dispatch({
      type: SET_COLUMN_FILTER,
      data: {
        type: 'NUMBER',
        value: '',
        argument: '',
        field: field,
      },
    });
    dispatch({
      type: TRIGGER_FILTERS,
    });
  };
  const handleApply = () => {
    if (argument === '') {
      setArgumentError(true);
      return;
    } else setArgumentError(false);
    if (inputValue === '') {
      setInputError(true);
      return;
    } else setInputError(false);
    let newValue = inputValue;
    if (isTimeInput()) {
      const timeInMiliseconds = formatToMilliseconds(inputValue);
      newValue = timeInMiliseconds;
    }
    dispatch({
      type: SET_COLUMN_FILTER,
      data: {
        type: 'NUMBER',
        value: newValue,
        argument: argument,
        field: field,
      },
    });
    dispatch({
      type: TRIGGER_FILTERS,
    });
  };
  const formatInput = (inputText) => {
    // Remove non-numeric characters
    const numericInput = inputText.replace(/\D/g, '');

    // Split the input into hours and minutes
    const hours = numericInput.substring(0, 3);
    const minutes = numericInput.substring(3, 5);

    // Format the input as "hh:mm"
    const formattedInput = `${hours}:${minutes}`;

    return formattedInput;
  };
  const isTimeInput = () => {
    return field != 'leaves' && field != 'workFromHomeDays';
  };
  const [inputValue, setInputValue] = useState(
    columnFilters?.[field]?.value == ''
      ? ''
      : formatMillisecondsTohhhmm(columnFilters[field].value),
  );
  const [argument, setArgument] = useState(columnFilters[field].argument);
  const [helperText, setHelperText] = useState('Select one');
  return (
    <>
      <div style={{ padding: '10px', width: '200px' }}>
        <FormControl error={argumentError} variant="standard">
          <FormHelperText>{helperText}</FormHelperText>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={argument}
            onChange={handleSelectChange}
          >
            {options.map((option) => (
              // <Box sx={{m:0, p:0}}>
              <FormControlLabel
                value={option.value}
                control={<Radio />}
                label={option.label}
              />
              // </Box>
            ))}
          </RadioGroup>
        </FormControl>

        <div style={{ marginTop: '10px' }}>
          <TextField
            label={isTimeInput() ? 'hhh:mm' : 'input'}
            variant="outlined"
            size="small"
            fullWidth
            value={inputValue}
            onChange={handleInputChange}
            onBlur={handleInputBlur} // Added onBlur event handler
            error={inputError}
          />
          <Button
            variant="outlined"
            size="small"
            style={{ marginTop: '10px' }}
            onClick={handleClearInput}
          >
            Clear Filter
          </Button>
          <Button
            variant="outlined"
            color="success"
            size="small"
            sx={{
              marginTop: '10px',
              marginLeft: '28px',
            }}
            onClick={handleApply}
          >
            Apply
          </Button>
        </div>
      </div>
    </>
  );
});
